export function getStepPanelId(value: string): string {
  return `wizard-step-panel-${value.replace(/[^a-zA-Z0-9_-]/g, "-")}`;
}
